import { NgModule } from '@angular/core'
import { FormsModule, ReactiveFormsModule } from '@angular/forms'
import { CommonModule } from '@angular/common'
import { CookieService } from 'ngx-cookie-service'
import { SeFeAlertModule } from 'se-fe-alert'
import { SeFeButtonModule } from 'se-fe-button'
import { SeFeDatepickerModule } from 'se-fe-datepicker'
import { SeFeFormFieldModule } from 'se-fe-form-field'
import { SeFeFormFieldOptionsModule } from 'se-fe-form-field-options'
import { SeFeFormFieldTextModule } from 'se-fe-form-field-text'
import { SeFeLinkModule } from 'se-fe-link'
import { SeFePopoverModule } from 'se-fe-popover'
import { SeFeSpinnerModule } from 'se-fe-spinner'
import {
  SeHouseholdSetupDataAccessStoreModule
} from '@se-po/se-household-setup-data-access-store'
import {
  SeHouseholdSetupFeatureAlreadyHaveAccountModule
} from '@se-po/se-household-setup-feature-already-have-account'

import { AccountInfoComponent } from './account-info/account-info.component'
import { AccountInfoFormCreateService } from './account-info/account-info-form-create.service'
import { AccountInfoFormSubmitService } from './account-info/account-info-form-submit.service'

@NgModule({
  declarations: [AccountInfoComponent],
  exports: [AccountInfoComponent],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    SeHouseholdSetupDataAccessStoreModule,
    SeHouseholdSetupFeatureAlreadyHaveAccountModule,
    SeFeAlertModule,
    SeFeButtonModule,
    SeFeDatepickerModule,
    SeFeFormFieldModule,
    SeFeFormFieldTextModule,
    SeFeFormFieldOptionsModule,
    SeFeFormFieldTextModule,
    SeFeLinkModule,
    SeFePopoverModule,
    SeFeSpinnerModule,
  ],
  providers: [
    AccountInfoFormCreateService,
    AccountInfoFormSubmitService,
    CookieService,
  ]
})
export class SeHouseholdSetupFeatureAccountInfoModule { }
